import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import type {
  UiStepValidationOrientation,
  UiStepValidationSize,
  UiStepValidationStatus,
  UiStepValidationStep,
} from './step-validation.types';

export type {
  UiStepValidationOrientation,
  UiStepValidationSize,
  UiStepValidationStatus,
  UiStepValidationStep,
} from './step-validation.types';

/**
 * Organismo: resumen de validación por etapas.
 *
 * Mantiene la jerarquía visual de Step Progress, sin conectores de avance.
 * Cada etapa comunica un estado documental y una cantidad opcional.
 */
@Component({
  selector: 'ui-step-validation',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet],
  templateUrl: './step-validation.component.html',
  styleUrl: './step-validation.component.scss',
  host: {
    class: 'ui-step-validation-host',
    '[attr.data-orientation]': 'orientation()',
    '[attr.data-size]': 'size()',
  },
})
export class UiStepValidationComponent {
  readonly steps = input.required<readonly UiStepValidationStep[]>();
  readonly orientation = input<UiStepValidationOrientation>('horizontal');
  readonly size = input<UiStepValidationSize>('md');
  readonly ariaLabel = input('Validación del proceso');
  readonly showStepNumber = input(true);
  readonly showStatusLabel = input(true);
  readonly showStatusCount = input(true);
  readonly interactive = input(false);
  readonly selectedId = input<string | null>(null);

  readonly stepSelect = output<UiStepValidationStep>();

  protected statusLabel(status: UiStepValidationStatus): string {
    switch (status) {
      case 'review':
        return 'En revisión';
      case 'observations':
        return 'Con observaciones';
      case 'rejected':
        return 'Rechazados';
      case 'validated':
        return 'Validado';
    }
  }

  protected stepAriaLabel(step: UiStepValidationStep, index: number): string {
    if (step.ariaLabel) return step.ariaLabel;
    const count = step.count === undefined ? '' : `. Cantidad: ${step.count}`;
    return `Paso ${index + 1}: ${step.label}. ${this.statusLabel(step.status)}${count}`;
  }

  protected isSelected(step: UiStepValidationStep): boolean {
    return this.selectedId() === step.id;
  }

  protected onStepSelect(step: UiStepValidationStep): void {
    if (!this.interactive()) return;
    this.stepSelect.emit(step);
  }
}
